import React, { FC } from 'react';

import { PRODUCT_NAME } from 'src/apps/dashboard/pages/issues/types/IssuesTypes';
import { WebSdkDetailsBlock } from 'src/apps/web-sdks/components/WebSdkDetailsBlock';
import { WfaDetailsBlock } from 'src/apps/wfa/components/WfaDetailsBlock';

import { IAllIssuesDetailsBlockProps } from './AllIssuesDetailsBlock.types';
import { MobileDashboardDetailsBlock } from './MobileDashboardDetailsBlock';

export const AllIssuesDetailsBlock: FC<IAllIssuesDetailsBlockProps> = ({
	productName,
	...rest
}) => {
	if (productName === PRODUCT_NAME.WEB_FLOW_ANALYZER) {
		return <WfaDetailsBlock {...rest} />;
	}

	if (
		productName === PRODUCT_NAME.MOBILE_FLOW_ANALYZER ||
		productName === PRODUCT_NAME.MOBILE_SDK
	) {
		return <MobileDashboardDetailsBlock productName={productName} {...rest} />;
	}

	return <WebSdkDetailsBlock {...rest} />;
};
